<script>
import { h } from 'vue'

/** 首页租赁概况用小图标（24×24 viewBox） */
export default {
  name: 'DashboardIcons',
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 18 },
    color: { type: String, default: 'currentColor' },
  },
  render() {
    const { name, size, color } = this
    const paths = ICON_PATHS[name]
    if (!paths) return null
    return h(
      'svg',
      {
        class: 'dash-icon',
        width: size,
        height: size,
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        'aria-hidden': 'true',
      },
      paths.map(d =>
        h('path', {
          d,
          stroke: color,
          'stroke-width': '1.6',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
        }),
      ),
    )
  },
}

const ICON_PATHS = {
  time: [
    'M12 7v5l3 2',
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
  ],
  service: [
    'M12 3l7 4v5c0 4.5-3 7.7-7 9-4-1.3-7-4.5-7-9V7l7-4z',
  ],
  traffic: [
    'M13 2L4 14h7l-1 8 9-12h-7l1-8z',
  ],
  buyout: [
    'M7 7h10v10H7z',
    'M9 12h6',
    'M12 9v6',
  ],
  channel: [
    'M4 7h16v10H4z',
    'M8 7V5h8v2',
    'M12 11v4',
  ],
  business: [
    'M6 6h5v5H6z',
    'M13 6h5v5h-5z',
    'M6 13h5v5H6z',
    'M13 13h5v5h-5z',
  ],
  network: [
    'M5 12h2M9 12h2M13 12h2M17 12h2',
    'M4 8h16M4 16h16',
    'M12 8v8',
  ],
  waterQuality: [
    'M12 3c-3 4-6 7-6 10a6 6 0 0 0 12 0c0-3-3-6-6-10z',
  ],
  waterUsage: [
    'M8 6h12M8 12h12M8 18h12',
    'M4 6h.01M4 12h.01M4 18h.01',
  ],
  offline: [
    'M16 11c1.7 0 3 1.3 3 3v1H5v-1c0-1.7 1.3-3 3-3',
    'M12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    'M4 19h16',
  ],
  fault: [
    'M12 8v5',
    'M12 17h.01',
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
  ],
  product: [
    'M4 7h16v12H4z',
    'M8 7V5h8v2',
  ],
  source: [
    'M3 7h18v10H3z',
    'M3 11h18',
  ],
  user: [
    'M16 11c1.7 0 3 1.3 3 3v1H5v-1c0-1.7 1.3-3 3-3',
    'M12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  ],
  trendUp: ['M6 15l6-6 6 6'],
  trendDown: ['M6 9l6 6 6-6'],
  expand: ['M6 9l6 6 6-6'],
  heart: [
    'M12 20.5l-1.1-1C6.5 14.8 4 12.4 4 9.5 4 7 6 5 8.5 5c1.5 0 3 1 3.7 2.1C13.2 6 14.7 5 16.2 5 18.7 5 20.7 7 20.7 9.5c0 2.9-2.5 5.3-7.9 10L12 20.5z',
  ],
  contractOff: [
    'M8 4h11l3 3v13H8z',
    'M8 8h14',
    'M11 12h6',
    'M10 16h4',
  ],
  wallet: [
    'M4 7h16v12H4z',
    'M4 11h16',
    'M16 15h4',
  ],
  signDoc: [
    'M8 4h11l3 3v13H8z',
    'M8 8h14',
    'M11 12h6',
  ],
  coins: [
    'M8 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    'M16 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    'M12 17a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  ],
  goalTarget: [
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
    'M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  ],
  goalLease: [
    'M14 4l-2 6h4l-2 6',
    'M8 20h8',
  ],
  goalBuyout: [
    'M8 6h8v12H8z',
    'M10 12h4',
  ],
  goalCollection: [
    'M12 3v18',
    'M8 7h8',
    'M9 11h6',
  ],
  goalRecruit: [
    'M16 11c1.7 0 3 1.3 3 3v1H5v-1c0-1.7 1.3-3 3-3',
    'M12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    'M20 8v4',
    'M18 10h4',
  ],
  asInstall: ['M12 4v8M9 7h6', 'M6 20h12', 'M8 20v-4h8v4'],
  asRepair: ['M14.7 6.3a4 4 0 0 0-5.4 5.4l6.7 6.7 2.1-2.1-6.7-6.7z', 'M11 9l3 3'],
  asInspect: ['M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2', 'M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2', 'M9 14l2 2 4-4'],
  asFilter: ['M4 6h16M7 12h10M10 18h4'],
  asPending: ['M5 5h14v14H5z', 'M9 9h6v6H9z'],
  asComplaint: ['M12 3v3', 'M5 10h14', 'M7 14h10', 'M9 18h6'],
  asEngineer: ['M12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M5 20v-1a7 7 0 0 1 14 0v1'],
  asFeeSettle: ['M12 3v18', 'M8 7h8', 'M9 11h6'],
  asWorkOrder: ['M8 4h11l3 3v13H8z', 'M8 8h14', 'M11 12h6'],
  asIncome: ['M12 3v18', 'M8 7h8', 'M9 11h6'],
  asExpense: ['M4 7h16v12H4z', 'M4 11h16', 'M8 15h8'],
  asUnbox: ['M12 2v10', 'M8 8l4-4 4 4'],
  asFaultDoc: ['M8 4h11l3 3v13H8z', 'M11 11h6', 'M11 15h4'],
  asPart: ['M9 5H7l-4 9v5h14v-5l-4-9H9z'],
  asFaultType: ['M12 8v5', 'M12 17h.01', 'M12 3l9 18H3l9-18z'],
  asReview: ['M12 17.3l-1.1-1C7.5 13.2 5 11 5 8.5 5 6.5 6.5 5 8.5 5c1.2 0 2.4.6 3.5 1.7C13.1 5.6 14.3 5 15.5 5 17.5 5 19 6.5 19 8.5c0 2.5-2.5 4.7-5.9 7.8L12 17.3z'],
}
</script>

<style scoped>
.dash-icon {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}
</style>
